import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
const endpoint = `${baseUrl}/api/repositorioPOA`;

const RepositorioPOAProyecto = {
  /**
   * @param {number} proyectoID
   * @param {number | undefined} estado 1=repositorio | 2=participantes | 3=contrapartida
   */
  getDato: async (proyectoID, estado) => {
    try {
      const response = await axios.get(`${endpoint}/${proyectoID}`, {
        params: estado ? { estado } : {},
        timeout: 5000,
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        console.error(
          `Error en la solicitud: ${error.response.status}`,
          error.response.data
        );
      } else if (error.request) {
        console.error("No se recibió respuesta del servidor", error.request);
      } else {
        console.error("Error en la configuración:", error.message);
      }
      throw error;
    }
  },
};

export default RepositorioPOAProyecto;
